import { strategyToOptions } from "@/common/utils/strategyToOptions"

export const diagnosticObjectiveActivityUnitForQuantity = {
  item: 'Unidades',
  hours: 'Horas',
}

export const diagnosticObjectiveActivityUnitForQuantityOptions = strategyToOptions(diagnosticObjectiveActivityUnitForQuantity);
